var map = {
	"./template.bet777": 1961,
	"./template.bet777.tsx": 1961,
	"./template.betgalaxy": 1962,
	"./template.betgalaxy.tsx": 1962,
	"./template.betprofessor": 1985,
	"./template.betprofessor.tsx": 1985,
	"./template.buffalobet": 1963,
	"./template.buffalobet.tsx": 1963,
	"./template.default": 142,
	"./template.default.tsx": 142,
	"./template.forsport": 1964,
	"./template.forsport.tsx": 1964,
	"./template.gigabet": 1965,
	"./template.gigabet.tsx": 1965,
	"./template.goldenbet888": 1966,
	"./template.goldenbet888.tsx": 1966,
	"./template.goldenrush": 1967,
	"./template.goldenrush.tsx": 1967,
	"./template.juicybet": 1968,
	"./template.juicybet.tsx": 1968,
	"./template.magnumbet": 1969,
	"./template.magnumbet.tsx": 1969,
	"./template.oldgill": 2056,
	"./template.oldgill.tsx": 2056,
	"./template.puntgenie": 1986,
	"./template.puntgenie.tsx": 1986,
	"./template.pyramidbet": 1970,
	"./template.pyramidbet.tsx": 1970,
	"./template.slambet": 1971,
	"./template.slambet.tsx": 1971,
	"./template.sterlingparker": 1972,
	"./template.sterlingparker.tsx": 1972,
	"./template.templebet": 1973,
	"./template.templebet.tsx": 1973,
	"./template.titanbet": 1974,
	"./template.titanbet.tsx": 1974,
	"./template.ts": 999
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2809;